var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_3216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4252 44.014L14.9102 49.7595L15.1093 47.4338L23.1503 38.9453L26.4252 44.014Z",
    fill: "#324C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6663 33.9686L42.0117 58.4786C42.297 58.7441 42.6439 58.9343 43.0211 59.032C43.3984 59.1298 43.794 59.1321 44.1723 59.0386C44.5506 58.9452 44.8997 58.7589 45.188 58.4968C45.4763 58.2346 45.6947 57.9047 45.8236 57.537L64.8641 3.12053C65.0049 2.71814 65.0334 2.28501 64.9465 1.86766C64.8596 1.45031 64.6606 1.06454 64.3709 0.751784C64.0812 0.439031 63.7118 0.211126 63.3023 0.0925601C62.8928 -0.0260061 62.4588 -0.0307514 62.0468 0.0788341L1.74362 16.1054C1.3383 16.2131 0.969262 16.4274 0.674916 16.7261C0.38057 17.0248 0.171681 17.397 0.0699996 17.8039C-0.031682 18.2107 -0.0224391 18.6374 0.0967661 19.0395C0.215971 19.4415 0.44078 19.8043 0.747786 20.09L15.6663 33.9686Z",
    fill: "#4E64EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7831 7.79688L23.0812 40.8597L15.0767 49.6281C14.9467 49.7667 14.7755 49.8596 14.5884 49.893C14.4014 49.9265 14.2085 49.8986 14.0386 49.8136C13.8686 49.7286 13.7306 49.5911 13.6451 49.4214C13.5596 49.2517 13.5312 49.0589 13.5641 48.8717L15.8104 34.1007L56.7831 7.79688Z",
    fill: "#3554B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_3216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 59.112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/Asset.08565dc3f912a8e0f0eff4fe79ea6d71.svg";
export { ForwardRef as ReactComponent };